import UserService from "@/services/User.service"
const _ = require('lodash')


const UserModule = {
    state: () => ({
    }),
    mutations: {
    },
    actions: {

    },
    getters: {
    }
}

export default UserModule;
